import React, { useState, useEffect } from 'react';
import { AiOutlineExclamationCircle, AiOutlineFileProtect } from "react-icons/ai";
import Badge from 'react-bootstrap/Badge';
import {
    FaTh,
    FaBars,
    FaFileInvoice,
    FaFileSignature,
    FaAlignLeft,
    FaTasks,
    FaFileMedical,
    FaReply,
    FaListUl,
    FaFolderOpen,
    FaClipboardCheck,
    FaHandsHelping,
    FaChartBar,
    FaUserPlus,
    FaClipboardList,
    FaLayerGroup,
    FaAdn,
    FaSignOutAlt,
    FaUserCircle,
    FaBookmark
}
    from "react-icons/fa";
import { LuFileEdit } from "react-icons/lu";
import { MdOutlineViewInAr } from "react-icons/md";

import { NavLink, useNavigate } from 'react-router-dom';
import FetchApi from './customhooks/functionFetchApi';

const Sidebar = ({ children, datastatus }) => {

    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(true);
    const toggle = () => setIsOpen(!isOpen);

    const handleLogout = () => {
        sessionStorage.clear();
        window.location.href = '/';
    };

    const FetchApis = new FetchApi();
    const Emcode = sessionStorage.getItem("EmCode");
    const [getMenuList, setGetMenuList] = useState([]);


    var arrey = [];
    var menuItem = [];
    menuItem = [
        {
            path: "/journalallstatus",
            name: "เอกสารทั้งหมด",
            icon: FaTh,
            active: ``
        },
        {
            path: "/reportstatusjournalall",
            name: "สถานะรอรับเอกสาร",
            icon: FaChartBar,
            active: ``
        },
        {
            path: "/journalstepflow",
            name: "Flow All",
            icon: FaBookmark,
            active: ``
        },
        {
            path: "/journalmanagement",
            name: "เอกสารของฉัน",
            icon: FaListUl,
            active: ``
        },
        {
            path: "/journallistrecieved",
            name: `เอกสารใหม่`,
            icon: FaFolderOpen,
            active: `${datastatus.preRecievd}`
        },
        {
            path: "/journallistconfirmproduct",
            name: `เอกสาร comfirm`,
            icon: FaFolderOpen,
            active: `${datastatus.preconfirm}`
        },
        {
            path: "/journallistbyapprove",
            name: `รออนุมัติ`,
            icon: FaClipboardCheck,
            active: `${datastatus.preReSend}`
        },
        {
            path: "/journallistrejectstatus",
            name: `เอกสารตีกลับ `,
            icon: FaReply,
            active: `${datastatus.preReject}`
        },
        {
            path: "/journalrejectdetail",
            name: `ฉันตีกลับเอกสาร`,
            icon: FaClipboardList,
            active: `${datastatus.CountReject}`
        },
        {
            path: "/journalrecallstatus",
            name: `แจ้งแก้ไขข้อมูล `,
            icon: LuFileEdit,
            active: `${datastatus.recallsend}`
        },
        {
            path: "/journallistdedicate",
            name: `อนุมัติแทน`,
            icon: FaHandsHelping,
            active: `${datastatus.countdedicate}`
        },
        {
            path: "/newjournal",
            name: "สร้างเอกสาร",
            icon: FaFileMedical,
            active: `${datastatus.newjournal}`
        },
        {
            path: "/journallistparta",
            name: `เอกสารร่าง`,
            icon: FaFileSignature,
            active: `${datastatus.draftjournal}`
        },
        {
            path: "/journallistprepass",
            name: `เอกสาร Prepress`,
            icon: FaFileSignature,
            active: `${datastatus.preReSend}`
        },
        {
            path: "/journallistaddspec",
            name: `เอกสาร Planning`,
            icon: FaAlignLeft,
            active: `${datastatus.preReSend}`
        },
        {
            path: "/journallistnewpartb",
            name: `เอกสาร RD `,
            icon: FaFileInvoice,
            active: `${datastatus.preReSend}`
        },
        {
            path: "/journallistfactory1",
            name: `เอกสาร Factory 1`,
            icon: FaFileInvoice,
            active: `${datastatus.preReSend}`
        },
        {
            path: "/journalprintinglist",
            name: `เอกสาร Printing`,
            icon: FaFileInvoice,
            active: `${datastatus.preReSend}`
        },
             {
            path: "/quaritylistjournal",
            name: `ตรวจสอบคุณภาพ`,
            icon: FaFileInvoice,
            active: `${datastatus.qualitytotal}`
        },
        
        {
            path: "/journalstatusapprove",
            name: `สถานะเอกสาร`,
            icon: FaTasks,
            active: ``,
        },
        {
            path: "/Journallistallpprovebyuser",
            name: `เอกสารอนุมัติแล้ว`,
            icon: FaTasks,
            active: ``,
        },
        {
            path: "/viewListbom",
            name: `รายการ Bom & Route`,
            icon: MdOutlineViewInAr,
            active: ``,
        },
        {
            path: "/journalbomllist",
            name: `เพิ่ม Bom & Route`,
            icon: FaLayerGroup,
            active: ``,
        },

        {
            path: "/createuser",
            name: "สร้างผู้ใช้งาน ",
            icon: FaUserPlus,
            active: ``
        },
                {
            path: "/flowsystem",
            name: "สร้าง flow ",
            icon: FaUserPlus,
            active: ``
        },
        {
            path: "/quaritygroup",
            name: "สร้าง Quality",
            icon: FaAdn,
            active: ``
        },

    ]

    useEffect(() => {
        loadingmenu()
    }, [])

    const loadingmenu = async () => {

        await FetchApis.FethcGet(`/groupmenusub/getmenulistByaccount/${Emcode}`).then((res) => {
            if (res.status == 200) {
                setGetMenuList(res.data.data);

            }
        })
    }

    function iconshow(data) {
        var dataicon = menuItem.find(item => item.path == data);
        if (dataicon != undefined) {

            arrey.push(dataicon)
        }
    }


    const username = sessionStorage.getItem("UserName");

    return (
        <div className="app-wrapper">
            {/* Top Header Bar */}
            <header className="top-header">
                <div className="header-left">
                    <button className="header-toggle-btn" onClick={toggle}>
                        <FaBars />
                    </button>
                    <div className="header-brand">
                        <span className="header-brand-main">E-TDS</span>
                        <span className="header-brand-sub">Document System</span>
                    </div>
                </div>
                <div className="header-right">
                    <div className="header-user-info">
                        <FaUserCircle size={18} />
                        <span className="header-username">{username || 'Guest'}</span>
                    </div>
                    <button onClick={handleLogout} className="header-logout-btn">
                        <FaSignOutAlt size={14} />
                        <span>ออกจากระบบ</span>
                    </button>
                </div>
            </header>

            {/* Sidebar + Main Content */}
            <div className="container-sidebar">
                <div style={{ width: isOpen ? "240px" : "52px" }} className="sidebar">
                    {isOpen && (
                        <div className="sidebar-brand-section">
                            <div className="sidebar-brand-text">Swan Industries</div>
                        </div>
                    )}

                    {
                        getMenuList.map((item, index) => {
                            { iconshow(item.path) }
                        })
                    }
                    {
                        arrey.length > 1 && arrey.map((item, index) =>
                        (<NavLink to={item.path} key={index} className="link" activeclassName="active" title={!isOpen ? item.name : ''}>
                            <div className="icon">
                                {item.name != 'เอกสารอนุมัติแล้ว' ? <item.icon /> : <AiOutlineFileProtect color='#4A76C4' size={18} />}
                            </div>
                            <div style={{ display: isOpen ? "block" : "none", fontSize: 12 }} className="link_text">
                                {item.name} {item.active > 0 && <Badge bg="danger" pill>{item.active}</Badge>}
                            </div>
                        </NavLink>)
                        )}
                </div>

                <div style={{ overflow: 'auto', width: '100%', backgroundColor: '#f8f9fb' }}>
                    <main>{children}</main>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;